module.exports = __webpack_public_path__ + "img/DS620.2f0871fc.jpg";